@if (loading) {
  <span class="text-sm text-color-secondary">...</span>
} @else if (!region) {
  <span [class]="cssClass">-</span>
} @else {
  <div
    class="region-display-cell"
    [class]="cssClass"
    [class.region-display-cell--align-left]="align === 'left'"
    [class.region-display-cell--align-right]="align === 'right'"
    [class.region-display-cell--align-center]="align === 'center'">
    @if (showRegion && showDistrict && regionParent) {
      <span class="region-display-cell__primary">{{ regionParent | serverTranslate: 'names' }}</span>
      <span class="region-display-cell__secondary">{{ (region | serverTranslate: 'names') || '-' }}</span>
    } @else if (showRegion && regionParent) {
      <span class="region-display-cell__primary">{{ regionParent | serverTranslate: 'names' }}</span>
    } @else if (showDistrict) {
      <span class="region-display-cell__primary">{{ (region | serverTranslate: 'names') || '-' }}</span>
      @if (regionParent && showRegion) {
        <span class="region-display-cell__secondary">{{ regionParent | serverTranslate: 'names' }}</span>
      } @else if (!regionParent) {
        <span class="region-display-cell__secondary">-</span>
      }
    } @else {
      <span class="region-display-cell__primary">-</span>
    }
  </div>
}
